import { render, staticRenderFns } from "./YiLianUserInfoQueryAuth.vue?vue&type=template&id=0982365a&scoped=true"
import script from "./YiLianUserInfoQueryAuth.vue?vue&type=script&lang=js"
export * from "./YiLianUserInfoQueryAuth.vue?vue&type=script&lang=js"
import style0 from "./YiLianUserInfoQueryAuth.vue?vue&type=style&index=0&id=0982365a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0982365a",
  null
  
)

export default component.exports